import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'
// import { OrbitControls } from '@react-three/drei'
import { Stats } from '@react-three/drei'
import * as dat from 'lil-gui'
import { currentJobProjectAtom, showHelpersAtom } from '../../store/store'
import { useAtom } from 'jotai'

const DebugGui = () => {
  const { camera } = useThree()
  // const controlsRef = useRef(null)
  const [showHelpers] = useAtom(showHelpersAtom)
  const [currentJobProject] = useAtom(currentJobProjectAtom)

  useEffect(() => {
    if (!showHelpers) return

    const gui = new dat.GUI({ closeFolders: false })
    const guiCameraFolder = gui.addFolder('Camera')
    const range = Math.PI

    camera.position.set(0, 14.57, 29.32)
    camera.rotation.set(-0.32, 0, 0)

    guiCameraFolder.add(camera.position, 'x').min(-60).max(60).step(0.01).name('positionX').listen()
    guiCameraFolder.add(camera.position, 'y').min(-60).max(60).step(0.01).name('positionY').listen()
    guiCameraFolder.add(camera.position, 'z').min(-60).max(60).step(0.01).name('positionZ').listen()

    // OrbitControls takes hold of the camera and do not allow to change the rotation programatically.
    // Comment the orbit controls and this will work, but it's more useful to keep it, at least that way we can
    // see the rotation values change when manipulated by the orbit controls.
    // NOTE: For rotation, use PI as the range values, since PI represents half of a rotation in a circle, however, to tweak the camera
    // I need smaller values, so I'm going with 0.5
    guiCameraFolder.add(camera.rotation, 'x').min(-range).max(range).step(0.01).name('rotationX').listen()
    guiCameraFolder.add(camera.rotation, 'y').min(-range).max(range).step(0.01).name('rotationY').listen()
    guiCameraFolder.add(camera.rotation, 'z').min(-range).max(range).step(0.01).name('rotationZ').listen()

    return () => {
      gui.destroy()
    }
  }, [camera, showHelpers])

  const getStats = () => {
    if (currentJobProject) return
    return <Stats showPanel={0} className="stats" />
  }

  // OrbitControls won't work without commenting the calls to cameraFollowMe in Bianca.tsx
  return (
    <>
      {getStats()}
      {/* <OrbitControls ref={controlsRef} makeDefault /> */}
    </>
  )
}

export default DebugGui
